import $ from "jquery";
import axios from "axios";
import config from "@/config";

export default {
  setLang: function({ commit }, payload) {
    commit("SET_LANG", payload);
  },
  addToCart: function({ state, commit }, product) {
    return new Promise((resolve) => {
      // if (state.cart.length > 0) {
      var index = state.cart.findIndex(function(val) {
        return val.id == product.id && val.option == product.option;
      });
      if (index != -1) {
        if (state.cart[index].quantity + product.quantity >= product.max) {
          commit("EDIT_QUANTITY", { index: index, quantity: product.max });
          // state.cart[index].quantity = product.max;
        } else if (state.cart[index].quantity + product.quantity < product.max) {
          // state.cart[index].quantity =
          commit("EDIT_QUANTITY", {
            index: index,
            quantity: state.cart[index].quantity + product.quantity,
          });
        } else {
          //console.log(state.cart[index], index);
        }
      } else {
        commit("ADD_CART", product);
      }
      resolve();
      // } else {
      //   commit("ADD_CART", product);
      // }
    });
  },
  updateAllCart({ commit }, cart) {
    commit("SET_ALL_CART", cart);
  },
  deleteFromCart: function({ state }, index) {
    state.cart.splice(index, 1);
  },
  deleteAllItemsInCart: function({ state }) {
    state.cart = [];
  },
  setCart: function({ state }, products) {
    state.cart = products;
  },
  getWholeSaleStatus: function({ commit }, pageid) {
    return new Promise((resolve, reject) => {
      var url = config.getConfig("serverUrl") + "wholesale_status?pageid=" + pageid;
      axios.get(url).then((response) => {
        response = response.data;
        if (response.responsecode == 200) {
          commit("SET_WHOLESALE_STATUS", response.data.wholesale_status === true);
          resolve();
        } else {
          reject();
        }
      });
    });
  },
  getWholeSale: function({ commit }, pageid) {
    return new Promise((resolve, reject) => {
      var url = config.getConfig("serverUrl") + "wholesale?pageid=" + pageid;
      axios.get(url).then((response) => {
        response = response.data;
        if (response.responsecode == 200) {
          commit("SET_WHOLESALE", response.wholesalelist);
          resolve();
        } else {
          reject();
        }
      });
    });
  },
  updateCartStock: function({ state, commit }, product) {
    var cartIndex = state.cart.findIndex(function(cart) {
      return cart.id == product.id && cart.optionDetail && cart.optionDetail[0] == product.stockid;
    });

    if (cartIndex || cartIndex === 0) {
      commit("SET_PRODUCT_IN_CART", {
        index: cartIndex,
        quantity: product.quantity,
      });
    }
  },
  updatePageProfile: function({}, user) {
    var url = config.getConfig("serverUrl") + "usershoplang";

    var data = {
      userid: user.userid,
      usershoplang: user.lang,
      pageid: user.pageid,
    };

    axios.put(url, data).then(() => {});
  },
  updateShopColor: function({ commit }, color) {
    commit("SET_THEME_COLOR", color);
  },
  loadPageProfile: function({ state, dispatch }, pagename) {
    return new Promise((resolve, reject) => {
      state.loadingPageProfile = true;
      dispatch("getPageProfile", pagename).then(
        (response) => {
          state.pageProfile = response;
          state.loadingPageProfile = false;
          resolve();
        },
        (error) => {
          // console.error(error)
          state.loadingPageProfile = false;
          reject(error);
        }
      );
    });
  },
  getPageProfile: async function({}, pagename) {
    var response = await axios.get(
      config.getConfig("serverUrl") + "pageprofile?pageid=" + pagename
    );
    response = response.data;
    if (response.responsecode == 200) {
      if (response.pageprofile) {
        return response.pageprofile;
      }
    } else {
      // console.log(response);
    }
  },
  getUserShopLang: async function({}, data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: "BEARER " + data.userid + " shop",
    };
    var url =
      config.getConfig("serverUrl") +
      "usershoplang?userid=" +
      data.userid +
      "&pageid=" +
      data.pageid;
    var response = await axios.get(url);
    if (response.data && response.data.responsecode == 200) {
      return response.data.data;
    } else {
      return null;
    }
  },
};
